// extracted by mini-css-extract-plugin
export var chip = "_55-0";
export var filterDropdown = "_55-5";
export var filterItem = "_55-6";
export var icon = "_55-1";
export var removeButton = "_55-3";
export var removeIcon = "_55-4";
export var separator = "_55-2";